import { Component, Input } from '@angular/core';

@Component({
  selector: 'cube-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  @Input() diameter = 80;
}
